<template>
  <div class="md-textarea" :class="{'has-errors': hasErrors}">
    
    <textarea
      v-validate="validate"
      :name="inputId"
      :id="inputId"
      class="form-control"
      :class="{'has-value': hasValue}"
      :value="value"
      :ref="inputId"
      @input="handleKeyDown($event)"
    ></textarea>
    <label :for="inputId">{{ label }}</label>

    <div ref="textareaBorder" class="textarea_border"></div>

    <transition name="fade">
      <div class="error-msg">{{ errors.first(inputId) }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "TextareaMaterialWrap",
  inject: ["$validator"],
  props: {
    label: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      default: "text"
    },
    value: {
      required: true
    },
    validate: {}
  },
  data() {
    return {
      val: this.value
    };
  },
  mounted(){
    this.autoResize()
  },
  computed: {
    hasErrors() {
      if (this.fields[this.inputId]) {
        if (this.fields[this.inputId].dirty) {
          if (this.fields[this.inputId].invalid) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    hasValue() {
      return this.value != "";
    }
  },
  methods: {
    handleKeyDown(event) {
      this.autoResize();
      this.$emit("input", event.target.value);
    },
    autoResize() {
      const el = this.$refs[this.inputId]
      setTimeout(() => {
        el.style.cssText = "height:auto;";
        el.style.cssText = "height:" + el.scrollHeight + "px;";
        setTimeout(() => {
          const borderEl = this.$refs.textareaBorder
          borderEl.style.cssText = "top:" + el.scrollHeight + "px";
        }, 0)
      }, 0)
    }
  }
};
</script>

<style lang="scss">
.md-textarea {
  position: relative;
  .textarea_border{
    top:0;
    border-bottom: 2px solid $info;
    position: absolute;
    width: 100%;
    transition: all 0.2s ease-in-out;
  }
  textarea {
    height: 0px ;
    overflow: hidden;
    min-height: 0px !important;
    position: relative;
    display: block;
    width: 100%;
    border: none;
    border-radius: 0px;
    background-color: transparent;
    margin: 0px auto;
    padding: 0px !important;
    height: 40px;
    outline: none !important;
    font-size: 1.35rem;
    color: $grey-light;
    background-position: left bottom;
    background-size: 0 1px;
    background-repeat: no-repeat;
    transition: all 0.2s ease-in-out;
    &:focus {
      background-position: left bottom;
      background-size: 100% 1px;
      border-color: $info;
    }
    // &.valid{
    //     border-color: $success;
    // }
    &.has-value + label {
      height: 20px;
      line-height: 20px;
      font-size: 11px;
      color: $grey;
    }
    &:focus + label {
      height: 20px;
      line-height: 20px;
      font-size: 11px;
      color: $info;
    }
  }
  label {
    position: absolute;
    top: -15px;
    left: 0;
    text-align: left;
    display: block;
    width: 100%;
    height: 52px;
    line-height: 72px;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 600;
    background: transparent;
    color: $grey;
    margin: 0px auto;
    cursor: text;
    transition: all 0.15s ease-in-out;
  }
  &.has-errors {
    input {
      border-color: $danger;
      &:focus + label {
        color: $danger;
      }
    }
    label {
      color: $danger !important;
    }
  }
  .error-msg {
    transition: 0.3s all;
    height: 22px;
    font-size: 0.9rem;
    color: $danger;
  }
}
</style>